<template>
    <div>
        <h2 class="pg_title">Label Print Search</h2>
        <!-- breadcrumbs -->
        <div class="bc_ico">
            Home
            <em>
                <span class="sr_only">&gt;</span>
            </em> HHP svc
            <em>
                <span class="sr_only">&gt;</span>
            </em> Label Print
        </div>
        <!-- //breadcrumbs -->
        <!-- srchTop_wrap -->
        <div class="srchTop_wrap">
            <article class="srch_basic">
                <div class="srch_grup">
                    <ul class="w49">
                        <li class="tit_150">Country</li>
                        <li data-input-type="select" class="w100-150">
                            <select class="slt_white w100">
                                <option>All</option>
                            </select>
                        </li>
                    </ul>
                    <ul class="w49">
                        <li class="tit_150">Model</li>
                        <li data-input-type="select" class="w100-150">
                            <select class="slt_white w100">
                                <option>All</option>
                            </select>
                        </li>
                    </ul>
                </div>
                <div class="srch_grupR">
                    <span class="btn">
                        <a href="JavaScript:" class="btn_srch">Search</a>
                    </span>
                </div>
            </article>
        </div>
        <!-- Grid -->
        <div class="grid_wrap">
            <!-- Count -->
            <div class="grid_total">
                Total Count
                <em>10</em>
            </div>
            <!-- Grid -->
            <div id="grid"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    components: {},
    created() {},
    data() {
        return {};
    },
    methods: {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/label/LabelList.vue